module.exports = __webpack_public_path__ + "static/mcgill-cf03ed64b7555f52ae079647fcd4e2a1.png";